const state = {
  tags: [],
};

const actions = {
  async getTags({ commit, rootState }) {
    commit('setTags', await rootState.storageProvider.getTags());
  },

  async getTag({ rootState }, { name }) {
    return rootState.storageProvider.getTag(name);
  },

  async updateTag({ dispatch, rootState }, { tag }) {
    await rootState.storageProvider.updateTag(tag);
    dispatch('getTags');
  },
};

const mutations = {
  setTags(state, tags) {
    state.tags = tags;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
